var defaultLabelMaxLength = 16;
var ellipsis = '…';
export var stringEllipsisAtMaxCharacters = function stringEllipsisAtMaxCharacters(stringToTruncate) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultLabelMaxLength;
  return stringToTruncate.length > maxLength ? "".concat(stringToTruncate.substr(0, maxLength - 1), " ").concat(ellipsis) : stringToTruncate;
};